import { Injectable } from '@angular/core';
import { FabricService } from '../fabric/fabric.service';
import { Observable, of } from 'rxjs';
import { ContactMessage } from '../../models/contact-message/contact-message';

const SERVICE_NAME = 'salesforce-resources';

@Injectable({
  providedIn: 'root'
})
export class PlansService {

  constructor(private fabricService: FabricService) {
  }

  unlockEnterprise(): Observable<any> {
    return this.fabricService.invokeOperation<any>(SERVICE_NAME, 'post_enterprise_status', {enterpriseStatus: true});
  }
}
